import {
    Alert,
    Box,
    Button,
    Container,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ErrorDetailContainer } from "../../api/config";
import { AccountService, OtpType } from "../../api/identity";
import { PageHeader } from "../../components/exports";
import ErrorParser from "../../components/shared/ErrorParser";
import PasswordInput from "../../components/shared/PasswordInput";

enum State {
    GetPassword = 1,
    Verfication = 2,
    Success = 3,
}

// updated
export default function AssignPassword() {
    const [state, setState] = useState<State>(State.GetPassword);

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
    const [otp, setOtp] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [newPasswordConfirmation, setNewPasswordConfirmation] =
        useState<string>("");
    const [error, setError] = useState<ErrorDetailContainer | null>(null);
    const [otpCoolDown, setOtpCoolDown] = useState<number>(60);

    useEffect(() => {
        const timer = setInterval(() => {
            if (otpCoolDown === 0) {
                return;
            }
            setOtpCoolDown(otpCoolDown - 1);
        }, 1000);
        return () => {
            clearTimeout(timer);
        };
    }, [otpCoolDown]);

    const handleOtpChange = (value: string) => {
        setOtp(value);
    };

    const handlePasswordChange = (value: string) => {
        setNewPassword(value);
    };

    const handlePasswordConfirmationChange = (value: string) => {
        setNewPasswordConfirmation(value);
    };

    const sendOtpCode = () => {
        if (newPassword !== newPasswordConfirmation) {
            setError(
                ErrorDetailContainer.fromString(
                    "رمز عبور و تایید رمز عبور مطابقت ندارد"
                )
            );
            return;
        }

        if (!/^(?=.*[0-9])(?=.*[a-z,A-Z]).{8}/.test(newPassword)) {
            setError(
                ErrorDetailContainer.fromString(
                    "رمز عبور با قوانین سایت سازگاری ندارد"
                )
            );
            return;
        }

        setRequestInProgress(true);
        AccountService.sendOtp(OtpType.CHANGE_PASSWORD)
            .then((r) => {
                setOtpCoolDown(60);
                setState(State.Verfication);
                setError(null);
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const confirmChangePassword = () => {
        setRequestInProgress(true);

        setError(null);

        AccountService.setPassword({
            newPassword: newPassword,
            otpCode: otp,
        })
            .then((success) => {
                if (success) {
                    setState(State.Success);
                    setError(null);
                } else {
                    setError(
                        ErrorDetailContainer.fromString(
                            "کد یکبارمصرف وارد شده صحیح نیست"
                        )
                    );
                }
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <Container maxWidth="xs">
            <PageHeader title="ویرایش رمز عبور" />

            <Box sx={{ p: 2 }}>
                {/* when success */}
                {state === State.Success && (
                    <Alert severity="success">
                        رمز عبور شما با موفقیت تغییر کرد
                    </Alert>
                )}

                {/* when getting password */}
                {state === State.GetPassword && (
                    <Paper sx={{ p: 2 }}>
                        <Stack spacing={2}>
                            <Alert severity={"info"}>
                                رمز عبور باید حداقل ۸ کاراکتر بوده و دارای حداقل
                                یک کارکتر لاتین و یک کاراکتر عدد باشد
                            </Alert>

                            <PasswordInput
                                label="رمز عبور جدید"
                                value={newPassword}
                                onChange={handlePasswordChange}
                            />

                            <PasswordInput
                                label="تکرار رمز عبور جدید"
                                value={newPasswordConfirmation}
                                onChange={handlePasswordConfirmationChange}
                            />

                            <ErrorParser error={error} />

                            <Button
                                fullWidth
                                variant="contained"
                                disabled={requestInProgress}
                                onClick={sendOtpCode}
                            >
                                ارسال رمز یک بار مصرف تایید
                            </Button>
                        </Stack>
                    </Paper>
                )}

                {/* when getting password */}
                {state === State.Verfication && (
                    <Paper sx={{ p: 2 }}>
                        <Stack spacing={2}>
                            <Typography color="text.secondary">
                                لطفا کد یکبار مصرف ارسال شده به شماره موبایل خود
                                را وارد کنید
                            </Typography>

                            <PasswordInput
                                label="کد یکبار مصرف"
                                value={otp}
                                onChange={handleOtpChange}
                            />

                            {otpCoolDown > 0 && (
                                <Typography
                                    color="text.secondary"
                                    textAlign="center"
                                >
                                    لطفا {otpCoolDown} ثانیه صبر کنید
                                </Typography>
                            )}

                            {otpCoolDown === 0 && (
                                <Button variant="text" onClick={sendOtpCode}>
                                    ارسال مجدد رمز
                                </Button>
                            )}

                            <ErrorParser error={error} />

                            <Button
                                fullWidth
                                variant="contained"
                                disabled={requestInProgress}
                                onClick={confirmChangePassword}
                            >
                                اعمال رمز عبور
                            </Button>
                        </Stack>
                    </Paper>
                )}
            </Box>
        </Container>
    );
}
